import React from 'react';
import CurrencyInput from '../CurrencyInput';

function RendimentoModal({ show, onClose, onSubmit, form, handleChange, programas = [], contas = [] }) {
    const [contasFiltradas, setContasFiltradas] = React.useState([]);
    const isEditing = form._isEditing;
    
    React.useEffect(() => {
      if (!form.idPrograma) {
        setContasFiltradas([]);
        return;
      }
      const filtradas = contas.filter(c => String(c.idPrograma) === String(form.idPrograma));
      setContasFiltradas(filtradas);
      if (filtradas.length === 1 && form.idConta !== filtradas[0].numConta) {
        handleChange({ target: { name: 'idConta', value: filtradas[0].numConta } });
      }
    }, [form.idPrograma, contas]);
  if (!show) return null;
  const meses = ['janeiro','fevereiro','marco','abril','maio','junho','julho','agosto','setembro','outubro','novembro','dezembro'];
  const mesesLabel = ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'];
  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1055, position: 'fixed', inset: 0 }}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header bg-success text-white" style={{ padding: '0.35rem 1rem' }}>
            <h6 className="modal-title mb-0 small"><i className="bi bi-graph-up-arrow me-2"></i>CADASTRO DE RENDIMENTO</h6>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <form onSubmit={onSubmit}>
              <div className="row">
                <div className="col-md-3 mb-3">
                  <label className="form-label">Programa *</label>
                  <select className="form-select form-select-sm" name="idPrograma" value={form.idPrograma} onChange={handleChange} required disabled={isEditing}>
                    <option value="">Selecione...</option>
                    {programas.map(p => <option key={p.id} value={p.id}>{p.descricao}</option>)}
                  </select>
                </div>
                <div className="col-md-3 mb-3">
                  <label className="form-label">Conta *</label>
                  <select className="form-select form-select-sm" name="idConta" value={form.idConta} onChange={handleChange} required disabled={isEditing}>
                    <option value="">Selecione...</option>
                    {contasFiltradas.map(c => <option key={c.numConta} value={c.numConta}>{c.numConta}</option>)}
                  </select>
                </div>
              </div>
              <div className="row">
                {meses.map((m, idx) => (
                  <div className="col-md-2 mb-2" key={m}>
                    <label className="form-label">{mesesLabel[idx]}</label>
                    <CurrencyInput className="form-control form-control-sm" name={m} value={form[m] || ''} onChange={handleChange} />
                  </div>
                ))}
              </div>
              <div className="d-flex justify-content-end gap-2 mt-3">
                <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
                <button type="submit" className="btn btn-success">Salvar</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RendimentoModal;
